import * as React from 'react';

function InfoErrorIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 26 26" fill="none" {...props}>
			<path
				d="M13 2.438a10.562 10.562 0 110 21.124 10.562 10.562 0 010-21.125zM13 26a13 13 0 100-26 13 13 0 000 26z"
				fill="currentColor"
			/>
			<path
				d="M12.266 15.377l-.218-7.51L12.008 6h1.649l-.04 1.867-.218 7.51h-1.133zm.576 4.172c-.318 0-.596-.113-.834-.338a1.213 1.213 0 01-.358-.894c0-.384.12-.688.358-.913.238-.239.517-.358.834-.358.332 0 .61.12.835.358.225.225.338.53.338.913 0 .358-.113.656-.338.894a1.134 1.134 0 01-.835.338z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default InfoErrorIcon;
